const IS_CAMPER = process.env.NEXT_PUBLIC_DOMAIN === 'camper';
const IS_NNORMAL = process.env.NEXT_PUBLIC_DOMAIN === 'nnormal';

export { IS_CAMPER, IS_NNORMAL };
